import FilterProcessor from './filterProcessor';

export default FilterProcessor.extend({
  addFilter(filter) {
    this.filters.reset([filter]);
    this.process();
  }
});
